export default __webpack_public_path__ + "static/media/pan-north.d6eaa62d.png";